import { isValidVideoPage } from './video/validation';
import {
  ARCHIVES_PAGE_TYPE,
  CHANNEL_PAGE_TYPE,
  CONTRIBUTOR_PAGE_TYPE,
  SEARCH_PAGE_TYPE,
  PRODUCT_DETAIL_PAGE_TYPE,
  STATIC_PAGE_TYPE,
  VIDEO_SERIES_PAGE_TYPE,
  PRODUCT_LIST_PAGE_TYPE
} from '../constants';

const getContainerModule = store => {
  const state = store.getState() || {};



  switch (state.analytics.page_type) {
    case ARCHIVES_PAGE_TYPE:
      return import(/* webpackChunkName: "archives" */ '../containers/archives');

    case CHANNEL_PAGE_TYPE:
    case CONTRIBUTOR_PAGE_TYPE:
      return import(/* webpackChunkName: "channel" */ '../containers/channel');

    case SEARCH_PAGE_TYPE:
      return import(/* webpackChunkName: "search" */ '../containers/search');

    case PRODUCT_DETAIL_PAGE_TYPE:
      return import(/* webpackChunkName: "product_detail" */ '../containers/product_detail');

    case PRODUCT_LIST_PAGE_TYPE:
      return import(/* webpackChunkName: "product_list" */ '../containers/product_list');

    case STATIC_PAGE_TYPE:
      return import(/* webpackChunkName: "static" */ '../containers/static');

    case VIDEO_SERIES_PAGE_TYPE: {
      if (isValidVideoPage(state)) {
        return import(/* webpackChunkName: "video_series" */ '../containers/video_series');
      }

      return import(/* webpackChunkName: "article" */ '../containers/article');
    }

    default:
      return import(/* webpackChunkName: "article" */ '../containers/article');
  }
};

export default store =>
  getContainerModule(store).then(module => module.default);
